var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1500,
    height: 800,
    viewBox: "0 360 1500 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 459h1360v660.504H70Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.293 459.672h1221.414c38.11 0 69 30.89 69 69v521.832c0 38.11-30.89 69-69 69H139.293c-38.11 0-69-30.89-69-69V528.672c0-38.11 30.89-69 69-69m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.078.602H1359v659.902H.078Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.293.672h1221.414c38.11 0 69 30.89 69 69v521.832c0 38.11-30.89 69-69 69H69.293c-38.11 0-69-30.89-69-69V69.672c0-38.11 30.89-69 69-69m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1360v661H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.973 994.79h68.406v68.405h-68.406Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526.176 994.79c-18.89 0-34.203 15.312-34.203 34.202s15.312 34.203 34.203 34.203c18.89 0 34.203-15.312 34.203-34.203 0-18.89-15.313-34.203-34.203-34.203m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.973.79h68.406v68.405H.973Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.176.79C16.286.79.973 16.101.973 34.991s15.312 34.203 34.203 34.203c18.89 0 34.203-15.312 34.203-34.203C69.379 16.102 54.066.79 35.176.79m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M957.691 994.79h68.407v68.405H957.69Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M991.895 994.79c-18.891 0-34.204 15.312-34.204 34.202s15.313 34.203 34.204 34.203c18.886 0 34.203-15.312 34.203-34.203 0-18.89-15.317-34.203-34.203-34.203m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.691.79h68.407v68.405H.69Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.895.79C16.004.79.69 16.101.69 34.991s15.313 34.203 34.204 34.203c18.886 0 34.203-15.312 34.203-34.203C69.098 16.102 53.78.79 34.895.79m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M679.613 575.883h123.235v123.234H679.613Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.23 575.883c-34.027 0-61.617 27.59-61.617 61.617 0 34.031 27.59 61.617 61.617 61.617 34.032 0 61.618-27.586 61.618-61.617 0-34.027-27.586-61.617-61.618-61.617m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.613.883h123.235v123.234H.613Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.23.883C28.203.883.613 28.473.613 62.5c0 34.031 27.59 61.617 61.617 61.617 34.032 0 61.618-27.586 61.618-61.617C123.848 28.473 96.262.883 62.23.883m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v125H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.352 545.086h1439.64v400.16H25.352Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.852 545.086h1346.312a46.49 46.49 0 0 1 32.879 13.621 46.49 46.49 0 0 1 13.621 32.879v307.16a46.5 46.5 0 0 1-46.5 46.5H71.852a46.5 46.5 0 0 1-32.883-13.617 46.52 46.52 0 0 1-13.617-32.883v-307.16a46.5 46.5 0 0 1 46.5-46.5m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.352.086h1439.367v400.16H.352Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.852.086h1346.312a46.49 46.49 0 0 1 32.879 13.621 46.49 46.49 0 0 1 13.621 32.879v307.16a46.5 46.5 0 0 1-46.5 46.5H46.852a46.5 46.5 0 0 1-32.883-13.617A46.52 46.52 0 0 1 .352 353.746V46.586a46.5 46.5 0 0 1 46.5-46.5m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1440v401H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.352 459.672h1439.64v400.16H25.352Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.852 459.672h1346.312a46.5 46.5 0 0 1 46.5 46.5v307.16a46.49 46.49 0 0 1-13.621 32.879 46.49 46.49 0 0 1-32.879 13.621H71.852a46.496 46.496 0 0 1-46.5-46.5v-307.16a46.5 46.5 0 0 1 13.617-32.883 46.5 46.5 0 0 1 32.883-13.617m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.352.672h1439.367v400.16H.352Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.852.672h1346.312a46.5 46.5 0 0 1 46.5 46.5v307.16a46.49 46.49 0 0 1-13.621 32.879 46.49 46.49 0 0 1-32.879 13.621H46.852a46.496 46.496 0 0 1-46.5-46.5V47.172a46.5 46.5 0 0 1 13.617-32.883A46.5 46.5 0 0 1 46.852.672m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1440v401H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.352 517.188H1465v272.398H25.352Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.852 517.188h1346.312a46.503 46.503 0 0 1 46.5 46.5v179.398a46.496 46.496 0 0 1-46.5 46.5H71.852a46.5 46.5 0 0 1-32.883-13.617 46.5 46.5 0 0 1-13.617-32.883V563.688a46.5 46.5 0 0 1 46.5-46.5m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.352.188h1439.367v272.398H.352Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.852.188h1346.312a46.503 46.503 0 0 1 46.5 46.5v179.398a46.496 46.496 0 0 1-46.5 46.5H46.852a46.5 46.5 0 0 1-32.883-13.617A46.5 46.5 0 0 1 .352 226.086V46.688a46.5 46.5 0 0 1 46.5-46.5m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1440v273H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.352 380.496H1465V726.72H25.352Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.852 380.496h1346.312a46.5 46.5 0 0 1 46.5 46.5V680.22a46.49 46.49 0 0 1-13.621 32.879 46.49 46.49 0 0 1-32.879 13.62H71.852a46.496 46.496 0 0 1-46.5-46.5V426.997a46.5 46.5 0 0 1 13.617-32.883 46.5 46.5 0 0 1 32.883-13.617m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.352.496h1439.367V346.72H.352Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.852.496h1346.312a46.5 46.5 0 0 1 46.5 46.5V300.22a46.49 46.49 0 0 1-13.621 32.879 46.49 46.49 0 0 1-32.879 13.62H46.852a46.496 46.496 0 0 1-46.5-46.5V46.997a46.5 46.5 0 0 1 13.617-32.883A46.5 46.5 0 0 1 46.852.496m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1440v347H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.969 619.45h934.09v361.218h-934.09Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1036.422 619.45c99.746 0 180.61 80.859 180.61 180.609 0 99.746-80.864 180.609-180.61 180.609H463.578c-99.746 0-180.61-80.863-180.61-180.61 0-99.75 80.864-180.609 180.61-180.609Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.969.45h934.07v361.218H.97Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.422.45c99.746 0 180.61 80.859 180.61 180.609 0 99.746-80.864 180.609-180.61 180.609H181.578c-99.746 0-180.61-80.863-180.61-180.61C.969 81.309 81.833.45 181.579.45Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h936v362H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h645v466H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(70 459)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd59",
    d: "M.293.672h1358.332v659.832H.293Zm0 0"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "translate(491 994)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.973.79h68.406v68.405H.973Zm0 0"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "translate(957 994)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.691.79h68.407v68.405H.69Zm0 0"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)",
    transform: "translate(679 575)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.613.883h123.235v123.234H.613Zm0 0"
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)",
    transform: "translate(25 545)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#17b1a4",
    d: "M.352.086h1439.64v400.16H.352Zm0 0"
  }))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)",
    transform: "translate(25 459)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#40448e",
    d: "M.352.672h1439.64v400.16H.352Zm0 0"
  }))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G)",
    transform: "translate(25 517)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cb6ce6",
    d: "M.352.188H1440.02v272.398H.352Zm0 0"
  }))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#K)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)",
    transform: "translate(25 380)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#M)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#N)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e66c6c",
    d: "M.352.496H1439.34V346.72H.352Zm0 0"
  }))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#O)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#P)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Q)",
    transform: "translate(282 619)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#R)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#S)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.969.45h934.09v361.218H.969Zm0 0"
  }))))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    fill: "#03265b",
    clipPath: "url(#T)",
    transform: "translate(425 590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.908 142.748q28.952.001 44.093 7.765c10.094 5.18 16.805 12.07 20.141 20.672q4.999 12.891 5 32.906v87.672H101.33v-12.109q-9.222 8.424-18.172 11.984-8.942 3.547-19.735 3.547-25.281.002-39.625-13.297-14.343-13.295-14.343-36.984c0-15.977 4.867-28.266 14.609-36.86 9.738-8.601 23.297-12.906 40.672-12.906q21.593.001 36.594 7.907c-.18-4.914-.922-8.82-2.235-11.72q-1.97-4.34-7.906-6.718-5.925-2.374-17.234-2.375H43.939v-39.484Zm-4.75 117.156q13.435.001 28.172-12.11v-13.953q-12.643-6.06-25.532-6.062-9.487.002-14.75 4.094-5.266 4.078-5.265 12.5-.001 8.688 4.468 12.11 4.483 3.42 12.907 3.421M255.613 92.2q37.905.001 57 16.72 19.092 16.721 19.094 49.89-.002 32.378-19.094 49.235-19.095 16.844-57 16.843h-33.437v66.875h-47.39V92.201Zm0 92.673q14.217.002 21.063-6.313 6.841-6.327 7.11-19.75 0-13.95-6.844-20.265-6.844-6.33-21.329-6.329h-33.437v52.657ZM344.87 79.295h45.797v39.75H344.87Zm0 63.453h45.797v149.015H344.87ZM463.337 295.185q-23.44 0-34.891-10.265-11.438-10.266-11.438-29.485V69.03h45.797v169.812q-.002 8.689 2.89 12.25c1.938 2.368 5.454 3.547 10.548 3.547 5.789 0 10.969-.703 15.531-2.109v38.969q-8.954 1.84-15.14 2.765-6.19.922-13.297.922M546.275 231.466q2.888 12.644 11.969 19.75c6.062 4.743 14.972 7.11 26.734 7.11q10.265.001 19.61-2.5 9.34-2.497 21.453-8.563l11.86 35.282c-9.138 5.093-18.18 8.648-27.126 10.656q-13.423 3.03-32.125 3.031-26.064-.002-44.36-9.86-18.3-9.873-27.78-27.78-9.47-17.906-9.47-41.594-.002-24.75 9.735-42.516 9.748-17.777 26.328-26.86 16.595-9.093 37.125-9.093c21.938 0 39.133 6.367 51.594 19.094q18.703 19.095 18.703 55.687v18.156Zm23.953-55.015q-9.487 0-15.406 4.734c-3.95 3.156-6.711 8.602-8.281 16.328h45.797c-.7-7.375-2.852-12.726-6.454-16.062q-5.39-4.999-15.656-5m0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.7a9919efe147b2af401eeba058f0dc07.svg";
export { ForwardRef as ReactComponent };